
import { createRouter, createWebHistory } from "vue-router"
import layout from "@/components/layout/horizontalIndex"
import store from "@/store"

export const routes = [
  {
    path: "/",
    redirect: () => {
      // 有首页权限则默认进首页；否则进第一个有权限的菜单
      const menus = store.state.menu || []
      const canSeeHome = menus.some(m => m && m.path === "/dashboard")
      if (canSeeHome) return "/dashboard"
      const first = store.state.firstMenuPath
      return first?.path || "/dashboard"
    },
    component: layout,
    code: 'dashboard',
    meta: {
      title: '首页'
    },
    children: [
      {
        path: "/dashboard",
        name: "HomeList",
        component: () => import("../views/home/index.vue"),
        meta: {
          hidden: true,
        },
      },
    ],
  },
  // {
  //   path: "/dashboard",
  //   name: "Home",
  //   component: layout,
  //   redirect: "/home/list",
  //   meta: {
  //     title: "首页",
  //   },
  //   children: [
  //     {
  //       path: "/home/list",
  //       name: "HomeList",
  //       component: () => import("../views/home/index.vue"),
  //       meta: {
  //         hidden: true,
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/payment/orderstat",
  //   name: "Statistics",
  //   component: layout,
  //   redirect: "/statistics/list",
  //   meta: {
  //     title: "订单统计",
  //   },
  //   children: [
  //     {
  //       path: "/statistics/list",
  //       name: "StatisticsList",
  //       component: () => import("../views/statistics/index.vue"),
  //       meta: {
  //         hidden: true,
  //         permission: 'payment:orderstat:query'
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/payment/order",
  //   name: "Order",
  //   component: layout,
  //   redirect: "/order/list",
  //   meta: {
  //     title: "订单查询",
  //   },
  //   children: [
  //     {
  //       path: "/order/list",
  //       name: "orderList",
  //       component: () => import("../views/orders/index.vue"),
  //       meta: {
  //         hidden: true,
  //         permission: 'payment:orderstat:query'
  //       },
  //     },
  //   ],
  // },
 
  // {
  //   path: "/system/roles",
  //   name: "Role",
  //   component: layout,
  //   redirect: "/role/list",
  //   meta: {
  //     title: "角色管理",
  //   },
  //   children: [
  //     {
  //       path: "/role/list",
  //       name: "RoleList",
  //       component: () => import("../views/roles/index.vue"),
  //       meta: {
  //         hidden: true,
  //         permission: "system:role:query",
  //       },
  //     },
  //   ],
  // },

  {
    path: "/system/users",
    component: layout,
    code: 'privilege',
    redirect: "/user/list",
    meta: {
      title: "权限管理",
      isRoot: true,
      children: true
    },
    children: [
      {
        path: "/user/list",
        name: "UserList",
        component: () => import("../views/users/index.vue"),
        meta: {
          title: "商户管理",
          hidden: false,
        },
      },
      {
        path: "/user-group/list",
        name: "UserGroupList",
        component: () => import("../views/users/group/index.vue"),
        meta: {
          title: "结算组管理",
          hidden: false,
        },
      },
    ],
  },
  {
    path: "/payment/pay",
    name: "Pay",
    code: 'payment',
    component: layout,
    redirect: "/pay/list",
    meta: {
      title: "支付系统",
      isRoot: true,
      children: true
    },

    children: [
      {
        path: "/account/list",
        name: "AccountList",
        component: () => import("../views/account/index.vue"),
        meta: {
        title: "通道管理",
          hidden: false,
        },
      },
      {
        path: "/a-site/list",
        name: "AList",
        component: () => import("../views/pay/a/index.vue"),
        meta: {
          hidden: false,
          title: '网站管理',
        },
      },
      {
        path: "/b-site/list",
        name: "BList",
        component: () => import("../views/pay/b/index.vue"),
        meta: {
          hidden: false,
          title: 'B站管理',
        },
      },

      {
        path: "/order/list",
        name: "OrderList",
        component: () => import("../views/orders/index.vue"),
        meta: {
          hidden: false,
          title: '订单管理',
        },
      },
      {
        path: "/order/ship/list",
        name: "OrderShipList",
        component: () => import("../views/orders/ship.vue"),
        meta: {
          hidden: false,
          title: '订单发货',
        },
      },
      {
        path: "/email/template/list",
        name: "EmailTemplate",
        component: () => import("../views/email/index.vue"),
        meta: {
          hidden: false,
          title: '邮件模版管理',
        },
      },
      {
        path: "/manual-order/list",
        name: "DomainList",
        component: () => import("../views/pay/domain-list.vue"),
        meta: {
          hidden: false,
          title: '私域付款订单',
        },
      },
      {
        path: "/gateway-order/list",
        name: "GatewayList",
        component: () => import("../views/pay/gateway-payment-list.vue"),
        meta: {
          hidden: false,
          title: '私域收款订单',
        },
      },
      {
        path: "/refund-order/list",
        name: "RefundOrderList",
        component: () => import("../views/pay/refund-order-list.vue"),
        meta: {
          hidden: false,
          title: '退款订单管理',
        },
      },
      {
        path: "/pay-link/list",
        name: "PaymentLinkList",
        component: () => import("../views/pay/payment-link-list.vue"),
        meta: {
          hidden: false,
          title: '支付连接管理',
        },
      },
      {
        path: "/order/detail",
        name: "OrderDetail",
        component: () => import("../views/pay/order-detail.vue"),
        meta: {
          hidden: true,
          title: '订单详情',
        },
      },
      {
        path: "/settlement/manage",
        name: "SettlementList",
        component: () => import("../views/pay/settlement-list.vue"),
        meta: {
          hidden: false,
          title: '结算管理',
        },
      },
      {
        path: "/adjust-bill/list",
        name: "AdjustBillList",
        component: () => import("../views/pay/adjust-bill-list.vue"),
        meta: {
          hidden: false,
          title: '手工调账',
        },
      },
      {
        path: "/fund-ledger/list",
        name: "FundLedgerList",
        component: () => import("../views/pay/fund-ledger/index.vue"),
        meta: {
          hidden: false,
          title: '资金流水',
        },
      },
      {
        path: "/fund-balance/list",
        name: "FundBalanceList",
        component: () => import("../views/pay/fund-balance/index.vue"),
        meta: {
          hidden: false,
          title: '商户资金',
        },
      },
    ],
  },
  {
    path: "/risk-manager",
    component: layout,
    code: 'risk-manager',
    redirect: "/black-list/manager",
    meta: {
      title: "风控管理",
      isRoot: true,
      children: true
    },
    children: [
      {
        path: "/black-list/manager",
        name: "blacklist-manager",
        component: () => import("../views/risk/blacklist.vue"),
        meta: {
          hidden: false,
          title: '黑名单管理',
        },
      },
    ],
  },
  {
    path: "/rdr_manage",
    component: layout,
    code: 'rdr_manage',
    redirect: "/report/order",
    meta: {
      title: "争议管理",
      isRoot: true,
      children: true
    },
    children: [
      {
        path: "/rdr/dispute/list",
        name: "RdrDisputeList",
        component: () => import("../views/rdr/dispute/index.vue"),
        meta: {
          hidden: false,
          title: 'rdr快速退款',
        },
      },
      {
        path: "/rdr/cbAlert/list",
        name: "CBAlertList",
        component: () => import("../views/rdr/cbAlert/index.vue"),
        meta: {
          hidden: false,
          title: '拒付拦截',
        },
      },
      {
        path: "/rdr/rtpInfo/list",
        name: "RtpInfoList",
        component: () => import("../views/rdr/rtpInfo/index.vue"),
        meta: {
          hidden: false,
          title: '拒付信息',
        },
      },
      {
        path: "/rdr/cbDescriptor/list",
        name: "CbDescriptorList",
        component: () => import("../views/rdr/cbDescriptor/index.vue"),
        meta: {
          hidden: false,
          title: '描述符管理',
        },
      },
    ],
  },
  {
    path: "/report-manager",
    component: layout,
    code: 'report-manager',
    redirect: "/report/order",
    meta: {
      title: "报表统计",
      isRoot: true,
      children: true
    },
    children: [
      {
        path: "/report/order",
        name: "order-report",
        component: () => import("../views/statistics/index.vue"),
        meta: {
          hidden: false,
          title: '商户统计',
        },
      },
      {
        path: "/report/channel",
        name: "channel-report",
        component: () => import("../views/statistics/channel.vue"),
        meta: {
          hidden: false,
          title: '通道统计',
        },
      },
      // {
      //   path: "/report/refund",
      //   name: "refund-report",
      //   component: () => import("../views/statistics/refund.vue"),
      //   meta: {
      //     hidden: false,
      //     title: '退款统计',
      //   },
      // },
    ],
  },
  {
    path: "/reconcile-manager",
    component: layout,
    code: 'reconcile-manager',
    redirect: "/gateway/reconcile",
    meta: {
      title: "对账",
      isRoot: true,
      children: true
    },
    children: [
      {
        path: "/gateway/reconcile",
        name: "gateway-reconcile",
        component: () => import("../views/reconcile/index.vue"),
        meta: {
          hidden: false,
          title: '网关对账',
        },
      },
      {
        path: "/gateway/reconcile-detail",
        name: "gateway-reconcile-detail",
        component: () => import("../views/reconcile/detail.vue"),
        meta: {
          hidden: false,
          title: '对账明细查询',
        },
      },
      {
        path: "/pay-order/reconcile-diff",
        name: "pay-order-reconcile-diff",
        component: () => import("../views/reconcile/payOrderReconcileDiff.vue"),
        meta: {
          hidden: false,
          title: '按笔对账差错',
        },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login/index.vue"),
    meta: {
      isRoot: false,
      title: "登录",
      hidden: true,
    },
  },
  {
    path: "/404",
    name: "404",
    component: () => import("../views/notFound.vue"),
  },
  {
    path: "/link/:id/result",
    name: "LinkResult",
    component: () => import("../views/linkResult.vue"),
  },
  {
    path: "/link/:id",
    name: "Link",
    component: () => import("../views/link.vue"),
  },
  {
    path: "/:catchAll(.*)",
    hidden: true,
    redirect: { path: "/404" },
  },
]

//异步挂载  带权限位路;
export const asyncRoutes = []
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export function resetRouter() {
  asyncRoutes.forEach(v => {
    if (router.hasRoute(v.name)) {
      router.removeRoute(v.name)
    }
  })
}
export default router
